import React, { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { SearchClear } from './SearchablePicker';

const itemId = (item) => item && (item._id || item.id);

const itemName = (list, id) => {
    const found = (list || []).find((entry) => itemId(entry) === id);
    if (!found) return id;
    return found.name || found.title || found.email || id;
};

const leftArray = (avalible = [], right = []) => (
    (avalible || [])
        .map(itemId)
        .filter((id) => id && !(right || []).includes(id))
);

const GridInput = ({ input, avalible }) => {
    const selected = Array.isArray(input.value) ? input.value : [];
    const [right, setRight] = useState(selected);
    const [left, setLeft] = useState(leftArray(avalible, selected));
    const [query, setQuery] = useState('');

    const apply = (nextLeft, nextRight) => {
        setLeft(nextLeft);
        setRight(nextRight);
        input.onChange(nextRight);
    };

    const addOne = (id) => apply(left.filter((item) => item !== id), right.concat([id]));
    const removeOne = (id) => apply(left.concat([id]), right.filter((item) => item !== id));

    const q = query.trim().toLowerCase();
    const visibleLeft = left.filter((id) => {
        if (!q) return true;
        return String(itemName(avalible, id)).toLowerCase().includes(q);
    });

    const addVisible = () => {
        if (!visibleLeft.length) return;
        apply(left.filter((id) => visibleLeft.indexOf(id) < 0), right.concat(visibleLeft));
    };

    const clearRight = () => {
        if (!right.length) return;
        apply(left.concat(right), []);
    };

    return (
        <div className="pc-xfer">
            <p className="pc-xfer__hint">Нажмите строку, чтобы добавить или убрать. Можно искать слева.</p>
            <div className="pc-xfer__cols">
                <div className="pc-xfer__col">
                    <div className="pc-xfer__hd">
                        <b>Доступные</b>
                        <span>{visibleLeft.length === left.length ? left.length : `${visibleLeft.length} из ${left.length}`}</span>
                    </div>
                    <div className="pc-xfer__search">
                        <div className="pc-pick-srch">
                            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
                                <circle cx="7" cy="7" r="4.5" />
                                <path d="M10.5 10.5L14 14" />
                            </svg>
                            <input
                                className="pc-pick-inp"
                                placeholder="Найти"
                                value={query}
                                onChange={(event) => setQuery(event.target.value)}
                            />
                            <SearchClear visible={Boolean(query)} onClear={() => setQuery('')} />
                        </div>
                    </div>
                    <div className="pc-xfer__list">
                        {visibleLeft.map((id) => (
                            <button key={id} type="button" className="pc-xfer__item" onClick={() => addOne(id)}>
                                <span>{itemName(avalible, id)}</span>
                                <AddIcon sx={{ fontSize: 16 }} />
                            </button>
                        ))}
                        {visibleLeft.length === 0 && (
                            <div className="pc-xfer__empty">
                                {left.length === 0 ? 'Все уже выбраны' : 'Ничего не найдено'}
                            </div>
                        )}
                    </div>
                    <button type="button" className="pc-xfer__all" disabled={!visibleLeft.length} onClick={addVisible}>
                        Добавить все{q ? ' найденные' : ''}
                    </button>
                </div>
                <div className="pc-xfer__col">
                    <div className="pc-xfer__hd">
                        <b>Выбранные</b>
                        <span>{right.length}</span>
                    </div>
                    <div className="pc-xfer__list pc-xfer__list--tall">
                        {right.map((id) => (
                            <button key={id} type="button" className="pc-xfer__item is-on" onClick={() => removeOne(id)}>
                                <span>{itemName(avalible, id)}</span>
                                <CloseIcon sx={{ fontSize: 15 }} />
                            </button>
                        ))}
                        {right.length === 0 && (
                            <div className="pc-xfer__empty">Пока ничего не выбрано — добавьте слева</div>
                        )}
                    </div>
                    <button type="button" className="pc-xfer__all" disabled={!right.length} onClick={clearRight}>
                        Убрать все
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GridInput;
